import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import Logo from "../../../../assets/img/logo-snps.svg";

// Styled Component
const StyledMenuContainer = styled(Box)(
  ({ theme }) => `
    top: 0;
    background: transparent;
    padding: 0 10%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: start;
  `
);

const StyledLogoContainer = styled(Box)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: flex-start;
    & img {
      width: 120px;
      height: auto;
      object-fit: contain;
      margin-bottom: ${theme.spacing(2.5)};
      margin-top: ${theme.spacing(2.5)};
      mix-blend-mode: multiply;
    }
  `
);

// Functional Component
const MenuContainer = ({ children, ...props }: BoxProps) => {
  return (
    <StyledMenuContainer {...props}>
      {/* Hardcoded Logo */}
      <StyledLogoContainer>
        <img
          src={Logo}
          alt="Logo"
          style={{ height: "60px", width: "auto" }} // Adjust dimensions as needed
        />
      </StyledLogoContainer>
      {/* Menu Content */}
      {children}
    </StyledMenuContainer>
  );
};

export default MenuContainer;
